export enum ContentTypesEnum {
    BankAccountLine  = 'bankaccountline',
    Cheque  = 'cheque',
    PurchaseInvoice = 'purchaseinvoice',
    SalesInvoice = 'salesinvoice',
}